// import styled from 'styled-components'

import { useState } from "react";
import { useProduct } from "../../contexts/ProductProvider";
import GlobalAccordionRow from "../global/GlobalAccordionRow";
import LinkUnderline from "../link/LinkUnderline";
import PriceRender from "../price/PriceRender";

interface P {
  rowState: any;
  className?: string;
}

const ProductAccordionPayments: React.FC<P> = ({
  className,
  rowState = useState(false),
  ...props
}: P) => {
  const { selectedVariant } = useProduct();
  const afterpayAmount = parseFloat(selectedVariant.price.amount) / 4;

  return (
    <GlobalAccordionRow
      className={className}
      rowState={rowState}
      title="Payment Options"
      {...props}
    >
      4 x&nbsp;
      <PriceRender
        amount={afterpayAmount}
        currencyCode={selectedVariant.price.currencyCode}
        showCurrency={false}
      />
      with&nbsp;
      <LinkUnderline href="https://www.afterpay.com/en-NZ/how-it-works">
        Afterpay
      </LinkUnderline>
    </GlobalAccordionRow>
  );
};

// const Wrapper = styled.div``

export default ProductAccordionPayments;
